module.exports = __webpack_public_path__ + "static/media/skull.d93af6c4.png";